import { useTranslation } from 'react-i18next'
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion'
import Card from '../../components/Card'
import SupportArticleContent from './SupportArticleContent'
import { cn } from '@/lib/utils'

const SupportFaqAccordion = ({
  entries,
}: {
  entries: wowaudit.SupportFaqEntry[]
}) => {
  const { t } = useTranslation()

  if (entries.length === 0) return null

  return (
    <section className='flex flex-col gap-3 max-w-3xl'>
      <h2 className='text-lg font-medium'>{t('support.faq-title')}</h2>
      <Card className='p-0 overflow-hidden'>
        <Accordion type='single' collapsible className='w-full'>
          {entries.map((entry, index) => (
            <AccordionItem
              key={entry.id}
              value={entry.id.toString()}
              className={cn(
                index === 0 ? 'border-t-0' : undefined,
                '[&>h3]:mb-0',
              )}
            >
              <AccordionTrigger className='w-full px-4 text-sm [&>svg]:shrink-0'>
                {entry.title}
              </AccordionTrigger>
              <AccordionContent>
                <div className='px-4 pb-3 text-sm'>
                  <SupportArticleContent content={entry.content} />
                </div>
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Card>
    </section>
  )
}

export default SupportFaqAccordion
